import type { ReactNode } from 'react';
import { BottomSheet } from '@/shared/components';

interface Props {
  /** Ab 1280 px ist der Kontext eine echte dritte Spalte, darunter ein Bottom-Sheet. */
  column: boolean;
  open: boolean;
  onClose: () => void;
  /** Zugänglicher Name — im Sheet zusätzlich sichtbar, damit der Rückweg beschriftet ist. */
  title: string;
  children: ReactNode;
}

/**
 * Hülle des Kontext-Panels: rechte Spalte auf Desktop, Bottom-Sheet darunter.
 *
 * FRONTEND_GUIDELINES §8. Vorher hing die Spalte an `xl:block` — unter 1280 px war der ganze
 * Kontext eines Threads schlicht nicht erreichbar, nicht einmal über einen Umweg. Muster
 * übernommen von `AkteDetailHost.tsx`.
 *
 * Die Umschaltung läuft bewusst über `column` aus `useMediaQuery` statt über eine
 * Tailwind-Breakpoint-Klasse: sonst entscheidet CSS über die Spalte und JavaScript über das
 * Sheet, und beim Größenwechsel stehen kurzzeitig beide da.
 */
export function ThreadContextHost({ column, open, onClose, title, children }: Props) {
  if (column) {
    return (
      <aside aria-label={title} className="w-[290px] flex-none overflow-y-auto">
        {children}
      </aside>
    );
  }
  if (!open) return null;
  return (
    <BottomSheet
      open
      onOpenChange={(v) => !v && onClose()}
      title={title}
      description="Aufenthalt, Gast, Apartment und Zugang zu dieser Unterhaltung."
      className="bg-card-alt"
    >
      {children}
    </BottomSheet>
  );
}
